import { postLogin, postGoogleLogin, setAuthorizationToken } from "../../../helpers/promedico_api_helper";
import { loginSuccess, logoutUserSuccess, apiError, reset_login_flag } from './reducer';
import { checkVersionOnLogin } from '../../../utils/versionManager';

const parseLoginError = (error: any): string => {
  // Extract error message from various possible locations
  const errorMessage = error?.message || error?.response?.data?.message || error?.response?.data?.detail || error?.toString() || '';

  console.log('Login error:', error);
  console.log('Error message:', errorMessage);

  // Map backend error messages to user-friendly Portuguese messages
  if (errorMessage.includes('pending approval') || errorMessage.includes('Account is pending approval')) {
    return 'Seu acesso foi requisitado e está aguardando aprovação do administrador.';
  }

  if (errorMessage.includes('deactivated') || errorMessage.includes('Account is deactivated')) {
    return 'Sua conta foi desativada. Entre em contato com o administrador.';
  }

  if (errorMessage.includes('Google sign-in') || errorMessage.includes('uses Google')) {
    return 'Esta conta utiliza login do Google. Use o botão "Continuar com Google".';
  }

  if (errorMessage.includes('Invalid credentials') || errorMessage.includes('Unauthorized') || error?.status === 401) {
    return 'E-mail ou senha incorretos. Verifique suas credenciais ou crie uma nova conta.';
  }

  // Generic error
  return 'Erro ao fazer login. Tente novamente mais tarde.';
};

export const loginUser = (user: any, history: any) => async (dispatch: any) => {
  try {
    const response: any = await postLogin({
      email: user.email,
      password: user.password
    });

    if (response && response.token) {
      const authData = {
        token: response.token,
        user: response.user,
        email: response.user.email,
        name: response.user.name,
        role: response.user.role,
      };

      sessionStorage.setItem("authUser", JSON.stringify(authData));
      setAuthorizationToken(response.token);

      dispatch(loginSuccess(authData));

      // Check for version updates on login
      await checkVersionOnLogin();

      history('/apps-chat');
    }
  } catch (error) {
    const friendlyError = parseLoginError(error);
    dispatch(apiError(friendlyError));
  }
};

export const logoutUser = () => async (dispatch: any) => {
  try {
    sessionStorage.removeItem("authUser");
    dispatch(logoutUserSuccess(true));
  } catch (error) {
    dispatch(apiError(error));
  }
};

export const socialLogin = (type: string, history: any) => async (dispatch: any) => {
  try {
    if (type === "google") {
      if (typeof window !== 'undefined' && (window as any).google) {
        const google = (window as any).google;
        google.accounts.id.initialize({
          client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID,
          callback: async (response: any) => {
            try {
              const credential = response.credential;
              const payload = JSON.parse(atob(credential.split('.')[1]));

              const googleLoginData = {
                googleId: payload.sub,
                email: payload.email,
                name: payload.name,
                avatarUrl: payload.picture
              };

              const apiResponse: any = await postGoogleLogin(googleLoginData);

              if (apiResponse && apiResponse.token) {
                const authData = {
                  token: apiResponse.token,
                  user: apiResponse.user,
                  email: apiResponse.user.email,
                  name: apiResponse.user.name,
                  role: apiResponse.user.role,
                };

                sessionStorage.setItem("authUser", JSON.stringify(authData));
                setAuthorizationToken(apiResponse.token);

                dispatch(loginSuccess(authData));

                // Check for version updates on login
                await checkVersionOnLogin();

                history('/apps-chat');
              }
            } catch (error) {
              const friendlyError = parseLoginError(error);
              dispatch(apiError(friendlyError));
            }
          }
        });

        google.accounts.id.prompt();
      } else {
        dispatch(apiError("SDK do Google Sign-In não carregado. Recarregue a página."));
      }
    } else {
      dispatch(apiError("Tipo de login social não suportado."));
    }
  } catch (error) {
    const friendlyError = parseLoginError(error);
    dispatch(apiError(friendlyError));
  }
};

export const resetLoginFlag = () => async (dispatch: any) => {
  try {
    const response = dispatch(reset_login_flag());
    return response;
  } catch (error) {
    dispatch(apiError(error));
  }
};
